export const content = {
  about: {
    heading: {
      en: "Do you want HIGH SCORE in your exam?",
      hi: "क्या आप अपनी परीक्षा में उच्च स्कोर करना चाहते हैं",
    },
    subHeading: {
      en: "Start your preparations with ToppersNotes's Study Material",
      hi: "ToppersNotes की अध्ययन सामग्री के साथ करे अपनी तैयारी शुरू",
    },
    feature1: {
      en: "Updated Syllabus, Paper Pattern & Full Exam Details",
      hi: "अपडेटेड पाठ्यक्रम, पेपर पैटर्न और पूर्ण परीक्षा विवरण",
    },
    feature2: {
      en: "Get FREE practice along with the Notes",
      hi: "नोट्स के साथ मुफ़्त अभ्यास प्राप्त करें",
    },
    feature3: {
      en: "Model Test Paper with Detailed Solutions",
      hi: "विस्तृत समाधान के साथ मॉडल टेस्ट पेपर",
    },
    feature4: {
      en: "Previous Years Question Papers & Answers",
      hi: "पिछले वर्षों के प्रश्न पत्र और उत्तर",
    },
  },
  step1: {
    heading: {
      en: "Get Counselling Call",
      hi: "काउंसलिंग कॉल प्राप्त करें",
    },
    subHeading: {
      en: "Get a call from our expert team of 5+ years of experience in {EXAM} and get HIGH SCORES",
      hi: "{EXAM} में 5+ वर्षों से ज्यादा अनुभव वाली हमारी विशेषज्ञ टीम से कॉल प्राप्त करें और उच्च स्कोर प्राप्त करें",
    },
    tnc: {
      en: "I agree to the Terms and Conditions.",
      hi: "मैं नियमों और शर्तों से सहमत हूँ",
    },
    notification: {
      en: "I agree to receive exam notifications via SMS/WhatsApp.",
      hi: "मैं एसएमएस/व्हाट्सएप के माध्यम से परीक्षा सूचनाएं प्राप्त करने के लिए सहमत हूँ",
    },
    close: {
      en: "Close",
      hi: "Close",
    },
    submit: {
      en: "Confirm",
      hi: "Confirm",
    },
  },
  step2: {
    heading: {
      en: "You're just one step away!",
      hi: "आप बस एक कदम दूर हैं!",
    },
    subHeading: {
      en: "We have sent you an OTP on your registered mobile no. ending ---010. Please verify it!",
      hi: "हमने आपको आपके पंजीकृत मोबाइल नंबर पर एक OTP भेजा है। समाप्त ----010. कृपया इसे वेरीफाई करें!",
    },
    changeMobile: {
      en: "Change mobile number",
      hi: "मोबाइल नंबर बदलें",
    },
    close: {
      en: "Close",
      hi: "Close",
    },
    submit: {
      en: "Submit",
      hi: "Submit",
    },
  },
  step3: {
    heading: {
      en: "Welcome to ToppersNotes!",
      hi: "टॉपर्स नोट्स में आपका स्वागत है",
    },
    subHeading: {
      en: "Call Confirmed!",
      hi: "कॉल कन्फर्म हो गई है!",
    },
    body: {
      en: "Our team will reach out to you soon!",
      hi: "हमारी टीम जल्द ही आप से सम्पर्क करेगी",
    },
  },
};

export const returnStep2SubHeading = (lang, phone) => {
  let subheading = "";
  if (lang == "en") {
    subheading = `We have sent you an OTP on your registered mobile no. ending ---${phone}. Please verify it!`;
  } else if (lang == "hi") {
    subheading = `हमने आपको आपके पंजीकृत मोबाइल नंबर पर एक OTP भेजा है। समाप्त ---${phone}. कृपया इसे वेरीफाई करें!`;
  }
  return subheading;
};

export const returnStep1SubHeading = (lang, exam) => {
  let subheading = "";
  if (lang == "en") {
    subheading = `Get a call from our expert team of 5+ years of experience and get HIGH SCORES`;
  } else if (lang == "hi") {
    subheading = `5+ वर्षों से ज्यादा अनुभव वाली हमारी विशेषज्ञ टीम से कॉल प्राप्त करें और उच्च स्कोर प्राप्त करें`;
  }
  return subheading;
};
